import React from 'react';
import { Card, CardContent } from '@shadcn/components/ui/card';

const isCurrentMonth = (monthStr) => {
  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth();
  
  const monthDate = new Date(monthStr);
  return monthDate.getFullYear() === currentYear && monthDate.getMonth() === currentMonth;
};

const SummaryCards = ({ loading, summaryData, selectedRegion, selectedMonths }) => {
  if (loading) {
    return (
      <Card className="mb-6">
        <CardContent className="p-6">
          <div className="flex justify-center items-center h-24">
            <div className="flex flex-col items-center">
              <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent"></div>
              <span className="mt-2 text-sm text-gray-500">Loading data...</span>
            </div>
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className="mb-6 overflow-hidden">
      <CardContent className="p-6">
        <h4 className="text-xl font-semibold mb-4">
          Forecast Summary for {selectedRegion}
        </h4>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {/* Card 1: Current Stock */}
          <div className="bg-gray-50 rounded-lg p-4">
            <div className="text-gray-500 text-sm mb-1">Current Stock</div>
            <div className="text-2xl font-bold">
              {summaryData.totalCurrentStock?.toLocaleString() || 0}
            </div>
          </div>
          
          {/* Card 2: Upcoming Stock */}
          <div className="bg-gray-50 rounded-lg p-4">
            <div className="text-gray-500 text-sm mb-1">Total Upcoming Stock</div>
            <div className="text-2xl font-bold">
              {summaryData.totalUpcomingStock?.toLocaleString() || 0}
            </div>
          </div>
          
          {/* Card 3: Month Cover & Stock Out */}
          <div className="bg-gray-50 rounded-lg p-4">
            <div className="text-gray-500 text-sm mb-1">Overall Month Cover</div>
            <div className="text-2xl font-bold">
              <span className={
                summaryData.overallMonthCover < 1 ? 'text-red-500' : 
                summaryData.overallMonthCover < 2 ? 'text-orange-500' : 
                'text-green-500'
              }>
                {summaryData?.overallMonthCover?.toFixed(2) || 0}
              </span>
            </div>
          </div>
          
          {/* Card 4: Monthly Forecast */}
          {console.log(selectedMonths)}
          <div className="bg-gray-50 rounded-lg p-4">
            <div className="text-gray-500 text-sm mb-2">Monthly Forecast</div>
            <div className="max-h-[140px] overflow-y-auto custom-scrollbar pr-1">
              {selectedMonths.map(month => (
                summaryData.monthlyForecast[month] && (
                <div key={month} className="mb-2 pb-2 border-b border-gray-200 last:border-0">
                  <div className="flex justify-between items-center">
                    <span className="text-sm font-medium">{month}:</span>
                    <span className="text-sm font-bold">
                      {summaryData.monthlyForecast[month]?.forecastTotal.toLocaleString() || 0}
                    </span>
                  </div>
                  
                  {summaryData.monthlyForecast[month]?.actualTotal > 0 && (
                    <div className="flex justify-between items-center mt-1">
                      <span className="text-xs text-gray-500">Actual:</span>
                      <span className="text-xs">
                        {summaryData.monthlyForecast[month]?.actualTotal.toLocaleString() || 0}
                      </span>
                    </div>
                  )}
                  
                  {isCurrentMonth(month) && summaryData.monthlyForecast[month]?.hasMtdData && (
                    <div className="flex justify-between items-center mt-1">
                      <span className="text-xs text-gray-500">MTD Sales:</span>
                      <span className="text-xs">
                        {summaryData.monthlyForecast[month]?.mtdSalesTotal.toLocaleString() || 0}
                        {summaryData.monthlyForecast[month]?.mtdDaysPassed && (
                          <span className="text-xs text-gray-400 ml-1">
                            ({summaryData.monthlyForecast[month]?.mtdDaysPassed} days)
                          </span>
                        )}
                      </span>
                    </div>
                  )}
                  
                  {summaryData.monthlyForecast[month]?.averageAccuracy !== null && (
                    <div className="flex justify-between items-center mt-1">
                      <span className="text-xs text-gray-500">Accuracy:</span>
                      <span className={`text-xs ${
                        summaryData.monthlyForecast[month]?.averageAccuracy > 90 ? 'text-green-500' : 
                        summaryData.monthlyForecast[month]?.averageAccuracy > 70 ? 'text-yellow-500' : 
                        'text-red-500'
                      }`}>
                        {summaryData.monthlyForecast[month]?.averageAccuracy.toFixed(1)}%
                      </span>
                    </div>
                  )}
                  </div>)
              ))}
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default SummaryCards;
